import { Components } from '@mui/material/styles';
import { Theme } from '@mui/material';

export const flowPagination: Components<Theme>['MuiPagination'] = {
  defaultProps: {
    variant: 'text',
    showFirstButton: true,
    showLastButton: true,
    siblingCount: 1,
    boundaryCount: 0,
  },
  styleOverrides: {
    root: ({ ownerState, theme }) => ({
      margin: '4px auto',
      ul: {
        flexWrap: 'nowrap',
        li: {
          minWidth: '0',
        },
        '& li:has(.MuiPaginationItem-previousNext):not(li:has(.MuiPaginationItem-previousNext) ~ li:has(.MuiPaginationItem-previousNext))':
          {
            marginRight: '37px',
            [theme.breakpoints.down('md')]: {
              marginRight: '18px',
            },
          },
        '& li:has(.MuiPaginationItem-previousNext):not(:has(~ li .MuiPaginationItem-previousNext))': {
          marginLeft: '37px',
          [theme.breakpoints.down('md')]: {
            marginLeft: '18px',
          },
        },
      },
      '&.MuiPagination-dots': {
        ul: {
          li: {
            padding: '0 2px',
            // style for mobile version for DOTS version
            [theme.breakpoints.down('md')]: {
              padding: '0',
              '& .MuiPaginationItem-root': {
                // hide items by default
                display: 'none',
                // only show navigation arrows and selected page
                '&.MuiPaginationItem-previousNext, &.MuiPaginationItem-firstLast, &.Mui-selected': {
                  display: 'inline-flex',
                },
                // adjust styling
                '&.Mui-selected': {
                  minWidth: '72px',
                },
              },
            },
          },
          '& li:has(.MuiPaginationItem-previousNext):not(li:has(.MuiPaginationItem-previousNext) ~ li:has(.MuiPaginationItem-previousNext))':
            {
              marginRight: '30px',
              [theme.breakpoints.down('md')]: {
                marginRight: '23px',
              },
            },
          '& li:has(.MuiPaginationItem-previousNext):not(:has(~ li .MuiPaginationItem-previousNext))': {
            marginLeft: '30px',
            [theme.breakpoints.down('md')]: {
              marginLeft: '23px',
            },
          },
        },
      },
      // remove extra page that is provided by @mui at the start/end of pagination
      ...(ownerState.boundaryCount === 0 &&
        ownerState.count > 5 && {
          // check if first ellipsis is not shown - hide last page
          [`&:not(:has(li:nth-of-type(${[ownerState.showFirstButton, !ownerState.hidePrevButton, true].filter(Boolean).length}) > .MuiPaginationItem-ellipsis))`]:
            {
              // last page
              [`& li:nth-last-of-type(${[ownerState.showLastButton, !ownerState.hideNextButton, true, true].filter(Boolean).length})`]:
                {
                  display: 'none',
                },
            },
          // check if last ellipsis is not shown - hide first page
          [`&:not(:has(li:nth-last-of-type(${[ownerState.showLastButton, !ownerState.hideNextButton, true].filter(Boolean).length}) > .MuiPaginationItem-ellipsis))`]:
            {
              // first page
              [`& li:nth-of-type(${[ownerState.showFirstButton, !ownerState.hidePrevButton, true, true].filter(Boolean).length})`]:
                {
                  display: 'none',
                },
            },
        }),
    }),
  },
};
